import { useRecoilValue } from "recoil"
import { localUserCallbackSelector } from "../../../recoil/atoms/users"
import { UserType } from "../../../constants/enums"
import {
  PrivateRoomData,
  PrivateRoomTabTarget
} from "../../../recoil/atoms/privateRoom"
import useMeetingClient from "../../../hooks/useMeetingClient"
import MOLocation from "../../../util/MOLocation"

const usePrivateRoom = () => {
  const meetingClient = useMeetingClient()
  const localUserCallbackProps = useRecoilValue(localUserCallbackSelector)

  const openPrivateRoom = async (
    { uniqueId, roomName, userName }: PrivateRoomData,
    targetType: PrivateRoomTabTarget
  ) => {
    // creating url
    const param = `sesId=${uniqueId}&roomName=${encodeURIComponent(
      roomName
    )}&userName=${encodeURIComponent(userName)}`
    const localUser = await localUserCallbackProps.handleReturnData()
    const location = MOLocation.getLocation()
    const currentParam = location.search
    const prevParam = currentParam ? `&${currentParam.substring(1)}` : ""
    const url = `${location.origin}${location.pathname}?${param}${prevParam}`

    // setting target
    let target = null
    if (targetType === "UN_DEF") {
      // if target is not define
      target = localUser.type === UserType.MODERATOR ? "_blank" : "_self"
    } else {
      target = targetType === "NEW_TAB" ? "_blank" : "_self"
    }

    // Open private room
    window.open(url, target)

    if (target === "_blank") {
      // Turn off mic, cam and screen-share
      if (localUser.micEnabled) {
        meetingClient?.toggleMic(localUser.micEnabled)
      }
      if (localUser.camEnabled) {
        meetingClient?.toggleCam(localUser.camEnabled)
      }
      if (localUser.screenShareEnabled) {
        meetingClient?.toggleScreenShare(
          localUser.screenShareEnabled,
          localUser.id
        )
      }
    }
  }

  return { openPrivateRoom }
}

export default usePrivateRoom
